import { ComponentType } from 'react'

import { useUser } from '../../hooks'

import { UserType } from '../../../types'

function withUser<T>(
  WrappedComponent: ComponentType<React.PropsWithChildren<T>>
): ComponentType<React.PropsWithChildren<T & { user: UserType }>> {
  return (props) => <WrappedComponent {...props} user={useUser()} />
}

export default withUser
